import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable, catchError, map, throwError} from 'rxjs';
import {AppConfigurationService} from '../../../erp/services/base/appConfiguration.service';

@Injectable({
  providedIn: 'root',
})
export class DocumentoPropostaEntidadeService {
  private subjectToken: BehaviorSubject<string> = new BehaviorSubject('');
  private subjectAutenticado: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor(
    private httpClient: HttpClient,
    private appConfigurationService: AppConfigurationService,
  ) {}

  buscarDocumentoPorTitularPropostaId(holderProposalId: string, proposalId?: string): Observable<any> {
    const url = `${this.appConfigurationService.apiBaseUrl}/documents/holder/${holderProposalId}?proposalId=${proposalId}`;
    return this.httpClient.get<any>(url).pipe(
      map(response => {
        return response;
      }),
      catchError(err => {
        return throwError(() => ({
          message: err.message,
          status: err.status,
        }));
      }),
    );
  }
  buscarDocumentoDependentePropostaId(dependentProposalId: string, proposalId?: string): Observable<any> {
    let url = `${this.appConfigurationService.apiBaseUrl}/documents/dependents/${proposalId}`;

    if (dependentProposalId !== undefined && dependentProposalId !== null) {
      url += `?dependentProposalId=${dependentProposalId}`;
    }

    return this.httpClient.get<any>(url).pipe(
      map(response => {
        return response;
      }),
      catchError(err => {
        return throwError(() => ({
          message: err.message,
          status: err.status,
        }));
      }),
    );
  }
  buscarDocumentoPorDependentePropostaId(proposalId: string, dependentProposalId?: string): Observable<any> {
    return this.httpClient
      .get<any>(
        `${this.appConfigurationService.apiBaseUrl}/documents/holder/${dependentProposalId}/?proposalId=${proposalId}`,
      )
      .pipe(
        map(response => {
          return response;
        }),
        catchError(err => {
          return throwError(() => ({
            message: err.message,
            status: err.status,
          }));
        }),
      );
  }
  validadeDocumento(nomeTipoArquivo: number, arquivo: any): Observable<Number> {
    const formData = new FormData();
    formData.append('file', arquivo);
    const url = `${this.appConfigurationService.apiBaseUrl}/Document/validate?documentType=${nomeTipoArquivo}`;
    return this.httpClient.post<Number>(url, formData).pipe(
      map(response => {
        return response;
      }),
      catchError(err => {
        return throwError(() => ({
          message: err.message,
          status: err.status,
        }));
      }),
    );
  }

  atualizarDocumento(codigoArquivo: number, arquivo: any): Observable<Number> {
    const formData = new FormData();
    formData.append('file', arquivo);

    return this.httpClient
      .put<Number>(
        `${this.appConfigurationService.apiBaseUrl}/documents/update?documentProposalId=${codigoArquivo}`,
        formData,
      )
      .pipe(
        map(response => {
          return response;
        }),
        catchError(err => {
          return throwError(() => ({
            message: err.message,
            status: err.status,
          }));
        }),
      );
  }

  enviarDocumentos(documentoVM: any, arquivo: any): Observable<Number> {
    const formData = new FormData();
    formData.append('file', arquivo);

    let url = `${this.appConfigurationService.apiBaseUrl}/documents/upload?proposalId=${documentoVM.proposalId}&documentType=${documentoVM.documentType}&description=${documentoVM.description}&groupDocument=${documentoVM.groupDocument}`;

    if (documentoVM.holderProposalId !== undefined && documentoVM.holderProposalId !== null) {
      url += `&holderProposalId=${documentoVM.holderProposalId}`;
    }

    if (documentoVM.dependentProposalId !== undefined && documentoVM.dependentProposalId !== null) {
      url += `&dependentProposalId=${documentoVM.dependentProposalId}`;
    }

    return this.httpClient.post<Number>(url, formData).pipe(
      map(response => {
        return response;
      }),
      catchError(err => {
        return throwError(() => ({
          message: err.message,
          status: err.status,
        }));
      }),
    );
  }

  atualizarStatusDocumento(documentoVM: any): Observable<Number> {
    return this.httpClient
      .patch<Number>(`${this.appConfigurationService.apiBaseUrl}/documents/update-status`, documentoVM)
      .pipe(
        map(response => {
          return response;
        }),
        catchError(err => {
          return throwError(() => ({
            message: err.message,
            status: err.status,
          }));
        }),
      );
  }

  enviarEmailDocumento(nomeTipoArquivo: number, arquivo: any): Observable<Number> {
    const formData = new FormData();
    formData.append('file', arquivo);
    const url = `${this.appConfigurationService.apiBaseUrl}/Document/validate?documentType=${nomeTipoArquivo}`;
    return this.httpClient.post<Number>(url, formData).pipe(
      map(response => {
        return response;
      }),
      catchError(err => {
        return throwError(() => ({
          message: err.message,
          status: err.status,
        }));
      }),
    );
  }

  cadastrarDadosDocumentos(titularVM: any[]): Observable<Number> {
    const url = `${this.appConfigurationService.apiBaseUrl}/documents/validate-document-send-email/${titularVM[0].proposalId}?sendColaborator=${titularVM[0].sendColaborator}`;

    return this.httpClient.post<Number>(url, titularVM).pipe(
      map(response => {
        return response;
      }),
      catchError(err => {
        return throwError(() => ({
          message: err.message,
          status: err.status,
        }));
      }),
    );
  }

  verificarStatusDocumentosPorProposta(proposalId?: string): Observable<any> {
    let url = `${this.appConfigurationService.apiBaseUrl}/documents/validate-documents/${proposalId}`;
    return this.httpClient.get<any>(url).pipe(
      map(response => {
        return response;
      }),
      catchError(err => {
        return throwError(() => ({
          message: err.message,
          status: err.status,
        }));
      }),
    );
  }
  buscarDocumentosRepravados(proposalId?: string): Observable<any> {
    let url = `${this.appConfigurationService.apiBaseUrl}/documents/corrections/${proposalId}`;
    return this.httpClient.get<any>(url).pipe(
      map(response => {
        return response;
      }),
      catchError(err => {
        return throwError(() => ({
          message: err.message,
          status: err.status,
        }));
      }),
    );
  }
}
